// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Flv8","title":"Info_title__13Kap","selects":"Info_selects__3yRdp","requiredAsterisk":"Info_requiredAsterisk__PZ1eY"};